import State from 'interfaces/state/State';
import { ITeamInvite } from 'interfaces/state/TeamInviteState';

export const isError$ = (state: State): boolean => state.teamInvite.isError;
export const isLoading$ = (state: State): boolean => state.teamInvite.isLoading;
export const teamInvites$ = (state: State): ITeamInvite[] => state.teamInvite.list;
